import fs from 'node:fs'
import path from 'node:path'
import type { StaticAssetComponent } from '@cli-types/next-adapter/commands.js'
import { resolveCliAssetPath } from '@cli-utils/paths.js'
export function getStaticAssetComponentEntries(
  assetDirectory: 'ui' | 'custom'
): StaticAssetComponent[] {
  const assetDir = resolveCliAssetPath('shared-assets', 'react-admin', assetDirectory)
  if (!fs.existsSync(assetDir)) return []

  const components: StaticAssetComponent[] = []

  for (const entry of fs.readdirSync(assetDir, { withFileTypes: true })) {
    if (entry.isFile() && (entry.name.endsWith('.tsx') || entry.name.endsWith('.ts'))) {
      components.push({
        name: entry.name.replace(/\.(tsx|ts)$/, ''),
        file: entry.name
      })
      continue
    }

    if (!entry.isDirectory()) {
      continue
    }

    const indexFile = ['index.tsx', 'index.ts'].find((file) =>
      fs.existsSync(path.join(assetDir, entry.name, file))
    )
    if (indexFile) {
      components.push({
        name: entry.name,
        file: path.join(entry.name, indexFile)
      })
    }
  }

  return components.sort((a, b) => a.name.localeCompare(b.name))
}
